import { popupStatus } from '@/constants/popup'
import { PopupStoreType } from '@/types/storeTypes/popupStoreTypes'
import { StateCreatorType } from '@/types/storeTypes/storeType'

const popupStore: StateCreatorType<PopupStoreType> = (set) => ({
  pagePopup: null,
  pagePopupStatus: popupStatus.CLOSED,

  setPagePopup: (page) =>
    set(
      (state) => {
        if (page === null) {
          return (state.popup.pagePopup = page)
        }

        state.popup.pagePopup = {
          ...page,
          pageOptions: {},
          prevPage: state.popup.pagePopup && {
            ...state.popup.pagePopup,
            focusId: page.pageOptions?.focusId,
            anchorId: page.pageOptions?.anchorId,
          },
        }
      },
      false,
      'setPagePopup',
    ),
  setPagePopupFocusId: (focusId) =>
    set(
      (state) => {
        if (state.popup.pagePopup) {
          state.popup.pagePopup.focusId = focusId
        }
      },
      false,
      'setPagePopupFocusId',
    ),
  setPagePopupAnchorId: (anchorId) =>
    set(
      (state) => {
        if (state.popup.pagePopup) {
          state.popup.pagePopup.anchorId = anchorId
        }
      },
      false,
      'setPagePopupAnchorId',
    ),
  setPagePopupSelectedTeamId: (teamId) =>
    set(
      (state) => {
        const pagePopup = state.popup.pagePopup

        if (pagePopup) {
          pagePopup.pageOptions = pagePopup.pageOptions || {}
          pagePopup.pageOptions.selectedTeamId = teamId
        }
      },
      false,
      'setPagePopupSelectedTeamId',
    ),
  setPagePopupTournamentWeek: (week) =>
    set(
      (state) => {
        const pagePopup = state.popup.pagePopup

        if (pagePopup) {
          pagePopup.pageOptions = pagePopup.pageOptions || {}
          pagePopup.pageOptions.tournamentWeek = week
        }
      },
      false,
      'setPagePopupTournamentWeek',
    ),
  setPagePopupStatus: (status) =>
    set(
      (state) => {
        state.popup.pagePopupStatus = status
      },
      false,
      'setPagePopupStatus',
    ),
  clearPagePopupOptions: () =>
    set(
      (state) => {
        const pagePopup = state.popup.pagePopup
        if (pagePopup) {
          pagePopup.pageOptions = {}
        }
      },
      false,
      'setPagePopupStatus',
    ),
  openPrevPage: () =>
    set(
      (state) => {
        state.popup.pagePopup = state.popup.pagePopup?.prevPage || null
      },
      false,
      'openPrevPage',
    ),
  closePagePopup: () =>
    set(
      (state) => {
        state.popup.pagePopupStatus = popupStatus.CLOSED
        state.popup.pagePopup = null
      },
      false,
      'closePagePopup',
    ),
  setTabIndex: (index: number) =>
    set(
      (state) => {
        if (state.popup.pagePopup) {
          state.popup.pagePopup.tabIndex = index
        }
      },
      false,
      'setTabIndex',
    ),
  setSlideIndex: (index: number) =>
    set(
      (state) => {
        if (state.popup.pagePopup) {
          state.popup.pagePopup.slideIndex = index
        }
      },
      false,
      'setTabIndex',
    ),
})

export default popupStore
